import { Skeleton } from "@mui/material";
import styles from "./loaderPaymentsPie.module.scss";

const LoaderPaymentsPie = () => {
    return (
        <div className={styles.skeletonContainer}>
            <div className={styles.skeletonLeft}>
                <Skeleton width={120} height={40}animation="wave" variant="text" />
                <Skeleton width={120} height={24} animation="wave" variant="text" />
            </div>
            <Skeleton animation="wave" width={120} height={24} variant="text" />
        </div>
    )
};

export default LoaderPaymentsPie;